/* eslint-disable react/jsx-props-no-spreading */
import React, { Fragment, useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@thd-olt-component-react/carousel';
import { extend } from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { dataModel as dpdSearchModel } from '../../../../hooks/dpdDataModel';

const SCREEN_MAX_SIZE = 1024;

const DPDCarousel = (props) => {
  const {
    carouselConfig,
    skus = [],
    channel,
    showDpdPod,
    showFavoritesCount,
    dpdNewTab,
    storeId,
    storeZip,
    linkType
  } = React.useMemo(() => ({
    carouselConfig: props.carouselConfig,
    skus: props.skus || [],
    channel: props.channel,
    showDpdPod: props.showDpdPod,
    showFavoritesCount: props.showFavoritesCount,
    dpdNewTab: props.dpdNewTab,
    storeId: props.storeId,
    storeZip: props.storeZip,
    linkType: props.linkType
  }), [props]);

  const isMobile = channel === 'mobile';
  if (typeof window !== "undefined" && window.innerWidth > 768)  {
    carouselConfig.screenMaxSize = SCREEN_MAX_SIZE + 20; // 20 for padding
  }

  return (
    <Carousel {...carouselConfig}>
      {skus.map((sku, index) => {
        const { info = {}, identifiers = {} } = sku;
        const { badges = [] } = info;
        const { itemId } = identifiers;
        const key = `${itemId || 'missing-item-id'}-${index}`
        return (
          <Fragment key={key}>
            {isMobile
              && (
                <ProductPod
                  channel={channel}
                  itemId={itemId}
                  storeId={storeId}
                  className="grid mobile-horizontal"
                  showFavoritesCount={showFavoritesCount}
                  showDpdPod={showDpdPod}
                  pageType="dpd"
                  segment=""
                  showSwatchFavoriteCount
                  target={linkType}
                  mobilePodType="singleColumn"
                  zipCode={storeZip}
                />
              )}
            {!isMobile
              && (
                <ProductPod
                  channel={channel}
                  showFavoritesCount={showFavoritesCount}
                  itemId={itemId}
                  storeId={storeId}
                  pageType="dpd"
                  segment=""
                  showSwatchFavoriteCount
                  target={linkType}
                  dpdNewTab={dpdNewTab}
                  mobilePodType="singleColumn"
                  hideShippingInfo
                  zipCode={storeZip}
                  hideStoreInfo
                  hideFulfillment
                />
              )}
          </Fragment>
        );
      })}
    </Carousel>
  )
}

DPDCarousel.dataModel = extend({}, dpdSearchModel, ProductPod);

DPDCarousel.propTypes = {
  channel: PropTypes.string,
  dpdNewTab: PropTypes.bool,
  skus: PropTypes.instanceOf(Array),
  linkType: PropTypes.string,
  storeId: PropTypes.string,
  storeZip: PropTypes.string,
  showFavoritesCount: PropTypes.bool,
  showDpdPod: PropTypes.bool
};

DPDCarousel.defaultProps = {
  channel: 'desktop',
  dpdNewTab: false,
  skus: [],
  linkType: '_self',
  storeId: undefined,
  storeZip: undefined,
  showFavoritesCount: false,
  showDpdPod: false
};

export default DPDCarousel;
